import { IPhoneNumber } from '../interface'
import { motion, AnimatePresence } from 'framer-motion'
import { useState } from 'react'
// import Icon from '@forwardflow/ui/Icons'

export const RealtorNumberItem = ({
   number,
   onChangeNumber,
}: // onDelete,
{
   number?: IPhoneNumber
   onChangeNumber?: () => void
   onDelete?: () => void
}) => {
   const [isHovered, setIsHovered] = useState(false)

   if (!number) return null

   return (
      <div className="flex flex-col bg-[#9061DA]/10 rounded-md mr-3">
         <div
            className="flex items-center justify-between bg-[#9061DA]/20 py-4 px-8 rounded-t-md"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
         >
            <div className="flex flex-col gap-y-1">
               <p className="font-medium text-white text-lg">
                  {number?.phoneNumber?.friendlyName}
               </p>
               <p className="text-white/70 text-sm">
                  {number?.phoneNumber?.locality || 'Unknown'}
               </p>
            </div>
            <div className="flex items-center gap-x-3">
               <AnimatePresence mode="wait">
                  {isHovered ? (
                     <>
                        <motion.button
                           key="change-button"
                           initial={{ opacity: 0, x: -10 }}
                           animate={{ opacity: 1, x: 0 }}
                           exit={{ opacity: 0, x: -10 }}
                           transition={{ duration: 0.2 }}
                           onClick={onChangeNumber}
                           className="bg-white/40 rounded-[4px] px-6 py-2 text-white text-sm font-medium transition-colors"
                        >
                           Change Number
                        </motion.button>
                        {/* <motion.button
                           key="delete-button"
                           initial={{ opacity: 0, scale: 0.8 }}
                           animate={{ opacity: 1, scale: 1 }}
                           exit={{ opacity: 0, scale: 0.8 }}
                           transition={{ duration: 0.2 }}
                           onClick={onDelete}
                           className="p-2 rounded-lg hover:bg-[#C11574]/20 transition-colors"
                        >
                           <Icon
                              name="Delete"
                              className="fill-[#FF6B9D]"
                              width={20}
                              height={20}
                           />
                        </motion.button> */}
                     </>
                  ) : (
                     <motion.div
                        key="badge"
                        initial={{ opacity: 0, x: 10 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 10 }}
                        transition={{ duration: 0.2 }}
                        className="bg-black/20 rounded-[4px] px-6 py-2"
                     >
                        <p className="text-white text-sm font-medium">
                           Realtor Call Line
                        </p>
                     </motion.div>
                  )}
               </AnimatePresence>
            </div>
         </div>
         <p className="text-white/70 text-sm p-2 px-4">
            Calls to agents will be placed from your Realtor Call Line.
         </p>
      </div>
   )
}
